import { lazy, Suspense } from 'react'
import { GemContentEditorBridge } from '@opallabs/gem-copilot'
import { TiptapEditorRegistryProvider } from '@opallabs/text-editor'

const ConnectedPostComponent = lazy(() => import('./connectedComponent'))

export const ConnectedPost: React.VFC = (props) => (
  <Suspense fallback={null}>
    <TiptapEditorRegistryProvider>
      <GemContentEditorBridge />
      <ConnectedPostComponent {...props} />
    </TiptapEditorRegistryProvider>
  </Suspense>
)
